import { useAccount } from "@/context/account";
import { gql } from "@/gql";
import { useQuery } from "@apollo/client/react";

export const DEALER_USERS = gql(`
  query DealerUsers($accountId: ID!) {
    dealerUsers(accountId: $accountId) {
      id
      email
      firstName
      lastLoginDate
      lastName
      role
      status
    }
  }
`);

type UseDealerUsersOptions = {
  skip?: boolean;
};

export const useDealerUsers = (options?: UseDealerUsersOptions) => {
  const { account } = useAccount();

  return useQuery(DEALER_USERS, {
    variables: { accountId: account.id },
    skip: !account.id || options?.skip === true,
  });
};
